export default __webpack_public_path__ + "static/media/za.3aba8a56.svg";